import type { TOC } from '@ember/component/template-only';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismModal, PrismTabsContainer } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and } from 'ember-truth-helpers';
import HotelBenchmarkInsightMarketCompositionMapMarketComposition from 'lumen/components/hotel/benchmark-insight/market-composition/map-market-composition';
import HotelBenchmarkInsightMarketCompositionMarketCompositionDetails from 'lumen/components/hotel/benchmark-insight/market-composition/market-composition-details';
import type HotelBenchmarkInsightMarketCompositionController from 'lumen/controllers/hotel/benchmark-insight/market-composition';

interface HotelBenchmarkInsightMarketCompositionSignature {
  Args: {
    controller: HotelBenchmarkInsightMarketCompositionController;
    model: unknown;
  };
}

<template>
  <div class="market-composition">
    <PrismModal
      @onClose={{@controller.onCloseModal}}
      @title={{t
        "benchmark_insight.market_composition.data_composition_report"
      }}
    >
      <div>
        {{#if @controller.marketComposition}}
          <PrismTabsContainer
            @activeTabId={{@controller.activeTab}}
            @onSelectTab={{@controller.onSelectTab}}
            @visibleTabIds={{@controller.availableTabs}}
            as |TabsContainer|
          >
            <TabsContainer.header {{didInsert @controller.onInit}}>
              <:default as |Header|>
                {{#each @controller.tabs as |tab|}}
                  <Header.tab @id={{tab.id}}>{{tab.label}}</Header.tab>
                {{/each}}
              </:default>
            </TabsContainer.header>

            <TabsContainer.content as |Content|>
              {{#each @controller.tabs as |tab|}}
                {{#if tab.market}}
                  <Content.tab @id={{tab.id}}>
                    <div class="market-composition__content">
                      {{#if (and tab.isMapVisible tab.market.marketShape)}}
                        <HotelBenchmarkInsightMarketCompositionMapMarketComposition
                          {{! @glint-expect-error: Incorrect type }}
                          @marketShape={{tab.market.marketShape}}
                        />
                      {{/if}}

                      <div class="market-composition__content--details">
                        <HotelBenchmarkInsightMarketCompositionMarketCompositionDetails
                          @categories={{tab.smartCompsetCategories}}
                          @market={{tab.market}}
                        />
                      </div>
                    </div>
                  </Content.tab>
                {{/if}}
              {{/each}}
            </TabsContainer.content>
          </PrismTabsContainer>
        {{/if}}
      </div>
    </PrismModal>
  </div>
</template> satisfies TOC<HotelBenchmarkInsightMarketCompositionSignature>;
